import HeroButton from "../Heros/HeroButton";
import HeroDescription from "../Heros/HeroDescription";
import HeroTitle from "../Heros/HeroTitle";
import SectionRoot from "./SectionRoot";
import SectionText from "./SectionText";

export const Section = {
    Root: SectionRoot,
    Title: HeroTitle,
    Button: HeroButton,
    Description: HeroDescription,
    Text: SectionText
}